import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.min.css';

export default class IntlTelInput extends Component {
  constructor(props) {
    super(props);
    // Intl Conf
    this.telInput = null;
    this.inputRef = React.createRef();
    // State
    this.state = {
      number: '',
    };
    // Bindings
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  // Component Functions
  componentDidMount() {
    this.rebuildIntlInput(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.lang !== prevProps.lang) {
      // When the language or initalCountry changes,
      // we need to update the component to translate country names
      this.telInput.destroy();
      this.rebuildIntlInput(this.props);
    }
    if (this.props.currentCountry !== prevProps.currentCountry && this.state.number === '') {
      this.setCurrentCountry(this.props.currentCountry);
    }
    if (this.props.number !== prevProps.number) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        number: this.props.number,
      });
    }
  }

  setCurrentCountry(currentCountry) {
    // With the try/catch we avoid the failure of unexisting country.
    try {
      this.telInput.setCountry(currentCountry);
    } catch (error) {
      // We don't want to do anything.
    }
  }

  buildIntlConfig(props) {
    const onlyCountries = [];
    const localizedCountries = {};

    props.countriesData.forEach((country) => {
      const countryCode = country.iso_code.toLowerCase();
      onlyCountries.push(countryCode);
      localizedCountries[countryCode] = country.name;
    });
    return {
      preferredCountries: [], // to override the component's default
      localizedCountries,
      onlyCountries,
    };
  }

  rebuildIntlInput(props) {
    const element = this.inputRef.current;
    this.telInput = intlTelInput(element, this.buildIntlConfig(props));
  }

  // SECTION Handlers
  onBlur() {
    // Si el número comienza por 1 dígito no contiene el dialCode y se lo añadimos.
    const { number } = this.state;
    const country = this.telInput.getSelectedCountryData();
    // Replace all currencies (/g) of spaces (/s+) by empty space ('');
    let phoneNumber = number.replace(/\s+/g, '');
    if (/^\d+$/.test(phoneNumber)) {
      phoneNumber = `+${country.dialCode} ${phoneNumber}`;
    }
    return this.props.onNumberBlur(phoneNumber);
  }

  onChange(event) {
    const { value } = event.target;
    this.setState({ number: value });
  }

  // SECTION Renders
  renderValidationError() {
    if (!this.props.validationError) {
      return null;
    }
    return (
      <span className="phone-input__validation-error">
        {this.props.validationError}
      </span>
    );
  }

  buildClasses() {
    let classes = 'form-input ';
    if (this.props.valid !== undefined) {
      classes += this.props.valid ? 'valid' : 'error';
    }
    return classes;
  }

  render() {
    const {
      label, required, number, disabled, placeholder, showLabel = true,
    } = this.props;
    return (
      <div className="phone-input FormControl">
        {showLabel && <label>{required ? `${label}*` : label}</label>}
        <input
          type="tel"
          ref={this.inputRef}
          onBlur={this.onBlur}
          className={this.buildClasses()}
          value={this.state.number || number}
          onChange={this.onChange}
          required={required}
          disabled={disabled}
          placeholder={placeholder}
          style={{
            backgroundColor: 'white',
            paddingTop: this.props.placeholder ? '12px' : undefined,
            paddingBottom: this.props.placeholder ? '12px' : undefined,
          }}
        />
        {this.renderValidationError()}
      </div>
    );
  }
}

IntlTelInput.propTypes = {
  countriesData: PropTypes.arrayOf(
    PropTypes.object,
  ),
  onNumberBlur: PropTypes.func,
  validationError: PropTypes.string,
  valid: PropTypes.bool,
  label: PropTypes.string,
  lang: PropTypes.string,
  currentCountry: PropTypes.string,
  required: PropTypes.bool,
  number: PropTypes.string,
  placeholder: PropTypes.string,
  showLabel: PropTypes.bool,
};
